import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { activeTab: String };

  connect() {
    // Set initial active tab (defaults to first tab if none specified)
    if (!this.activeTabValue && this.tabTargets.length > 0) {
      this.activeTabValue = this.tabTargets[0].dataset.tabId;
    }
    this.showActiveTab();
  }

  switch(event) {
    event.preventDefault();
    const tabId = event.currentTarget.dataset.tabId;
    this.activeTabValue = tabId;
    this.showActiveTab();
    this.updateURL(tabId);
  }

  showActiveTab() {
    // Update tab buttons
    this.tabTargets.forEach((tab) => {
      const tabId = tab.dataset.tabId;
      const isActive = tabId === this.activeTabValue;

      if (isActive) {
        tab.classList.remove(
          "text-gray-500",
          "border-transparent",
          "hover:text-gray-700",
          "hover:border-gray-300"
        );
        tab.classList.add("text-indigo-600", "border-indigo-500");
      } else {
        tab.classList.remove("text-indigo-600", "border-indigo-500");
        tab.classList.add(
          "text-gray-500",
          "border-transparent",
          "hover:text-gray-700",
          "hover:border-gray-300"
        );
      }
    });

    // Update panels
    this.panelTargets.forEach((panel) => {
      const panelId = panel.dataset.tabPanel;
      const isActive = panelId === this.activeTabValue;

      if (isActive) {
        panel.classList.remove("hidden");
      } else {
        panel.classList.add("hidden");
      }
    });
  }

  activeTabValueChanged() {
    this.showActiveTab();
  }

  updateURL(tabId) {
    // Update the URL without reloading the page
    const url = new URL(window.location);
    url.searchParams.set("tab", tabId);
    window.history.pushState({}, "", url);
  }
}
